class PartService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  getParts(params) {
    return this.apiService.get('/api/v1/one/part', params);
  }

  createPart(params) {
    return this.apiService.post('/api/v1/one/part', params);
  }

  updatePart(params) {
    return this.apiService.put(`/api/v1/one/part/${params.id}`, params);
  }

  deletePart(params) {
    return this.apiService.delete('/api/v1/one/part', params);
  }
}

export default PartService;
